module.exports = __webpack_public_path__ + "img/pencil-write.ec19b014.svg";